<form [formGroup]="americanCitizenshipForm()">
  <h2>Amerikanskt medborgarskap och skattskyldighet i USA</h2>
  <p>Den som är skattskyldig i USA (US Person) är bland annat:</p>

  <ul>
    <li>Person som är bosatt i USA</li>
    <li>Amerikansk medborgare (även person med dubbelt medborgarskap)</li>
    <li>Innehavare av amerikanskt uppehålls- och arbetstillstånd (s.k. Green
      card)
    </li>
    <li>Företag som är registrerat i USA</li>
  </ul>

  <p class="select-title">Vänligen bekräfta din status gällande amerikanskt
    medborgarskap.</p>
  <mat-radio-group
    tabindex="0"
    class="column"
    [class.selection-error]="hasAmericanCitizenshipError ||
    (americanCitizenshipForm().get('americanCitizenship')?.invalid &&
    americanCitizenshipForm().get('americanCitizenship')?.touched)"
    formControlName="americanCitizenship"
    aria-required="true"
    [attr.aria-invalid]="hasAmericanCitizenshipError"
    [attr.aria-describedby]="citizenshipErrorId">
    <mat-radio-button [value]="false"
                      class="margin-bottom-small"
                      [class.small-screen]="orientationService.isSmallScreen()"

    >Jag är inte amerikansk medborgare
      och/eller har ingen skatterättslig hemvist i USA
    </mat-radio-button>

    <mat-radio-button [value]="true">Jag är amerikansk medborgare och/eller har
      skatterättslig hemvist i USA
    </mat-radio-button>
  </mat-radio-group>
  @if (hasAmericanCitizenshipError) {
    <div class="mat-error-container">
      <mat-icon class="negative" aria-hidden="true">priority_high</mat-icon>
      <mat-error id="citizenship-error" [style.max-width.rem]="34">Ditt svar
        stämmer inte med dina
        tidigare svar, vänligen gå tillbaka och kontrollera dina svar.
      </mat-error>
    </div>
  }


  @if (americanCitizenshipForm().get('americanCitizenship')?.invalid && americanCitizenshipForm().get('americanCitizenship')?.touched) {
    <div class="mat-error-container">
      <mat-icon aria-hidden="true" class="negative">priority_high</mat-icon>
      <mat-error id="citizenship-validation-error">Vänligen gör ett val
      </mat-error>
    </div>
  }
</form>